export const LIBRARY_DATA_DOWNLOAD = "LIBRARY_DATA_DOWNLOAD";
export const LIBRARY_DATA_LOADING = "LIBRARY_DATA_LOADING";

export const LibraryDownloadTypes = {
	LIBRARY_DATA_DOWNLOAD,
	LIBRARY_DATA_LOADING
}